const steps = [
  {
    number: '01',
    icon: 'ri-user-add-line',
    title: '회원가입 후 상세정보 등록',
    color: '#2E7D6B',
    bg: 'rgba(46,125,107,0.08)',
    desc: '회원가입 후 환자 또는 간병인 상세 정보를 등록합니다.',
    items: [
      { text: '휴대폰 번호로 간편하게 회원가입' },
      { text: '환자: 간병 장소(집/병원), 병명, 간병 조건 등 등록' },
      { text: '간병인: 경력, 자격증, 가능 지역, 희망 시급 등 등록' },
    ],
    cta: { label: '회원가입 하러가기', href: '/app' },
  },
  {
    number: '02',
    icon: 'ri-search-line',
    title: '조건에 맞는 환자나 간병인을 검색',
    color: '#1a6b5a',
    bg: 'rgba(26,107,90,0.08)',
    desc: '원하는 조건에 맞는 환자나 간병인을 검색하여 매칭 제안을 합니다.',
    items: [
      { text: '지역, 경력, 시급, 가능 요일 등 상세 필터 검색' },
      { text: '환자와 간병인 양방향 매칭 제안 가능' },
      { text: '상대방 프로필을 확인하고 원하는 조건으로 제안' },
    ],
    cta: null,
  },
  {
    number: '03',
    icon: 'ri-hand-heart-line',
    title: '매칭 진행 및 정산',
    color: '#2E7D6B',
    bg: 'rgba(46,125,107,0.08)',
    desc: '양 당사자간 제안을 수락하면 연락처가 공개되고, 간병을 진행합니다. 간병이 완료되면 양당사자간 간병비를 직접 정산하고, 간병수수료를 당사에 입금합니다.',
    items: [
      { text: '매칭 수락 시 상대방 연락처 즉시 공개' },
      { text: '당사자 간 직접 간병 일정 및 조건 협의' },
      { text: '간병 완료 후 간병비 직접 정산, 중개 수수료 당사 입금' },
    ],
    cta: null,
  },
];

export default function ProcessSteps() {
  return (
    <section className="w-full py-14 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="space-y-5">
          {steps.map((step, idx) => (
            <div key={idx} className="flex gap-5 items-stretch">
              {/* Left: Step number + connector */}
              <div className="flex flex-col items-center flex-shrink-0">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center font-black text-white text-sm flex-shrink-0"
                  style={{ backgroundColor: step.color }}
                >
                  {step.number}
                </div>
                {idx < steps.length - 1 && (
                  <div
                    className="w-0.5 flex-1 mt-2"
                    style={{ backgroundColor: 'rgba(46,125,107,0.15)', minHeight: '24px' }}
                  ></div>
                )}
              </div>

              {/* Right: Content card */}
              <div
                className="flex-1 rounded-2xl border p-6 mb-5"
                style={{ backgroundColor: '#fafffe', borderColor: 'rgba(46,125,107,0.12)' }}
              >
                {/* Title row */}
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: step.bg }}
                  >
                    <i className={`${step.icon} text-base`} style={{ color: step.color }}></i>
                  </div>
                  <h3 className="text-base font-bold text-gray-900">{step.title}</h3>
                </div>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{step.desc}</p>

                {/* Items */}
                <ul className="space-y-2 mb-4">
                  {step.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span
                        className="mt-1 w-4 h-4 flex items-center justify-center rounded-full flex-shrink-0"
                        style={{ backgroundColor: step.bg }}
                      >
                        <i className="ri-check-line text-xs" style={{ color: step.color }}></i>
                      </span>
                      <span className="text-sm text-gray-700 leading-relaxed">
                        {item.text}
                      </span>
                    </li>
                  ))}
                </ul>

                {/* CTA button */}
                {step.cta && (
                  <div className="mt-4">
                    <a
                      href={step.cta.href}
                      className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
                      style={{ backgroundColor: step.color }}
                    >
                      <i className="ri-arrow-right-line"></i>
                      {step.cta.label}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Summary flow bar */}
        <div
          className="mt-10 rounded-2xl p-6"
          style={{ background: 'linear-gradient(135deg, #0d2b24 0%, #1a4a3a 100%)' }}
        >
          <p className="text-xs font-semibold tracking-widest uppercase mb-4" style={{ color: '#6fcfb8' }}>SUMMARY</p>
          <div className="flex flex-wrap items-center gap-2">
            {['회원가입 및 등록', '환자/간병인 검색', '매칭 진행 및 정산'].map((label, i, arr) => (
              <>
                <div
                  key={label}
                  className="px-4 py-2 rounded-xl text-xs font-bold text-white"
                  style={{ backgroundColor: 'rgba(255,255,255,0.12)' }}
                >
                  {String(i + 1).padStart(2, '0')}. {label}
                </div>
                {i < arr.length - 1 && (
                  <i key={`arr-${i}`} className="ri-arrow-right-line text-sm" style={{ color: 'rgba(255,255,255,0.3)' }}></i>
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}